var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusInCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.3C13.0317 16.3 16.3 13.0317 16.3 9C16.3 4.96832 13.0317 1.7 9 1.7C4.96832 1.7 1.7 4.96832 1.7 9C1.7 13.0317 4.96832 16.3 9 16.3ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM8.92483 4.57422C9.39427 4.57422 9.77483 4.95478 9.77483 5.42422V8.03125H12.5758C13.0452 8.03125 13.4258 8.41181 13.4258 8.88125C13.4258 9.35069 13.0452 9.73125 12.5758 9.73125H9.77483V12.5758C9.77483 13.0452 9.39427 13.4258 8.92483 13.4258C8.45539 13.4258 8.07483 13.0452 8.07483 12.5758V9.73125H5.42422C4.95478 9.73125 4.57422 9.35069 4.57422 8.88125C4.57422 8.41181 4.95478 8.03125 5.42422 8.03125H8.07483V5.42422C8.07483 4.95478 8.45539 4.57422 8.92483 4.57422Z",
    fill: "url(#paint0_linear_3883_4165)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3883_4165",
    x1: 3.75,
    y1: 14.25,
    x2: 16.5,
    y2: 3.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInCircle);
export default __webpack_public_path__ + "static/media/plus_in_circle.1861a4d33af8d7ee7d7d36ad53f36e55.svg";
export { ForwardRef as ReactComponent };